import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook, Linkedin, HeartPulse } from "lucide-react";
import { siteInfo, services } from "../data/mock";

export default function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-gray-300">
      <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 rounded-full bg-[#b81d24] flex items-center justify-center">
              <HeartPulse className="w-6 h-6 text-white" />
            </div>
            <div className="leading-tight">
              <div className="text-white font-extrabold">DR MAMTESH GUPTA</div>
              <div className="text-[10px] tracking-[0.25em] text-gray-400">CARDIOLOGIST</div>
            </div>
          </div>
          <p className="text-sm text-gray-400 leading-relaxed">
            Senior consultant Cardiologist in Meerut providing advanced cardiac care, interventional procedures and compassionate, patient-focused treatment.
          </p>
          <div className="flex items-center gap-3 mt-5">
            <a href={siteInfo.socials.instagram} className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#b81d24] transition-colors"><Instagram className="w-4 h-4" /></a>
            <a href={siteInfo.socials.facebook} className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#b81d24] transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href={siteInfo.socials.linkedin} className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#b81d24] transition-colors"><Linkedin className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-amber-400">Home</Link></li>
            <li><Link to="/about" className="hover:text-amber-400">About</Link></li>
            <li><Link to="/expertise" className="hover:text-amber-400">Expertise</Link></li>
            <li><Link to="/patient-education" className="hover:text-amber-400">Patient Education</Link></li>
            <li><Link to="/contact" className="hover:text-amber-400">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4">Our Services</h4>
          <ul className="space-y-2 text-sm">
            {services.slice(0, 6).map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="hover:text-amber-400">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-amber-400 flex-shrink-0" /><span>{siteInfo.fullAddress}</span></li>
            <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-0.5 text-amber-400 flex-shrink-0" /><a href={`tel:${siteInfo.phone}`}>{siteInfo.phoneFull}</a></li>
            <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 text-amber-400 flex-shrink-0" /><a href={`mailto:${siteInfo.email}`}>{siteInfo.email}</a></li>
            <li className="flex items-start gap-3"><Clock className="w-4 h-4 mt-0.5 text-amber-400 flex-shrink-0" /><span>{siteInfo.hours.weekday}<br />{siteInfo.hours.sunday}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} Dr. Mamtesh Gupta. All Rights Reserved.</p>
          <p>Designed with care for better heart health.</p>
        </div>
      </div>
    </footer>
  );
}
